import { render } from "./GameRounded.vue?vue&type=template&id=40cade45&scoped=true"
import script from "./GameRounded.vue?vue&type=script&lang=js"
export * from "./GameRounded.vue?vue&type=script&lang=js"

import "./GameRounded.vue?vue&type=style&index=0&id=40cade45&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40cade45"]])

export default __exports__